// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"684389d6","30":"740b41b0","839":"2f8921f1","855":"36c480f2","896":"03c98750"}[chunkId] + ".chunk.css";
};